import { decodeRSA } from './function';

const menu = [{
  groups: ['1', '2'],
  title: 'IMPORTAR',
  route: 'Import',
  icon: 'fas fa-cloud-upload-alt',
}, {
  groups: ['1', '2'],
  title: 'GEOCODIFICAR',
  icon: 'fas fa-map-pin',
  children: [{
    title: 'SIMPLE',
    route: 'Geocode',
  }, {
    title: 'MÚLTIPLE',
    route: 'GeocodeList',
  },
  {
    title: 'ENVIAR PUNTOS A GEOCODING',
    route: 'SendPointsToGeocoding',
  },
  {
    title: 'CARGA MASIVA',
    route: 'ImportPoints',
  }],
}, {
  groups: ['1', '2'],
  title: 'PLANIFICAR',
  icon: 'fas fa-map',
  children: [{
    title: 'ADMINISTRAR SOC',
    route: 'admin',
  },
  {
    title: 'PLANIFICAR',
    route: 'planning',
  },
  {
    title: 'PLANIFICAR POR SECTORES',
    route: 'PlanningV4',
  },
  {
    title: 'PLANIFICAR EN SIMPLIROUTE',
    route: 'PlanningSimpliroute',
  },
  {
    title: 'ADMINISTRAR RUTAS',
    route: 'modify',
  }, {
    title: 'ADMINISTRAR NODOS',
    route: 'DistributionCenterConfigs',
    groups: ['1'],
  }, {
    title: 'ESTADOS',
    route: 'Status',
  }, {
    title: 'ADMINISTRAR ZONAS',
    route: 'ZonesModify',
  }, {
    title: 'PRIORIZAR ZONAS',
    route: 'ZonesPriority',
 // }, {
 //   title: 'STS',
 //   route: 'planning-sts',
  }, {
    title: 'COLABORATIVOS',
    route: 'collaborative',
  },
  ],
}, {
  groups: ['1', '2'],
  title: 'SUBORDEN',
  icon: 'fas fa-clipboard-list',
  route: 'Suborder',
}, {
  groups: ['3', '6'],
  title: 'REPORTERÍA',
  icon: 'fas fa-file-invoice',
  route: 'Reporter',
}, {
  groups: ['1', '2'],
  title: 'REPORTERÍA',
  icon: 'fas fa-file-invoice',
  children: [{
    title: 'TRANSPORTISTA',
    route: 'Reporter',
  }, {
    title: 'GEOCODIFICACIÓN',
    route: 'ReporterGeo',
  }],
}, {
  groups: ['5'],
  title: 'REPORTERÍA',
  icon: 'fas fa-file-invoice',
  route: 'ReporterSupervisorOnly',
}, {
  groups: ['1', '2'],
  title: 'RUTAS',
  route: 'Routes',
  icon: 'fas fa-location-arrow',
}, {
  groups: ['1'],
  title: 'USUARIOS',
  icon: 'fas fa-users',
  children: [{
    title: 'ADMINISTRAR',
    route: 'UserList',
  }, {
    title: 'CREAR CUENTA',
    route: 'UserRegister',
  }, {
    title: 'CAMBIAR CONTRASEÑA',
    route: 'UserChangePass',
  }],
}, {
  groups: ['1'],
  title: 'SEGUIMIENTO',
  icon: 'fas fa-eye',
  children: [{
    title: 'SIMPLE',
    route: 'TracingV1',
  }, {
    title: 'EMPRESA',
    route: 'TracingEnterpriseV1',
  }, {
    title: 'CAMBIAR ESTADO DE ORDEN',
    route: 'ChangeStatusOrder',
  }, {
    title: 'CAMBIAR ORIGEN DE RUTA',
    route: 'ChangeRouteOrigin',
  }, {
    title: 'CAMBIAR LOCALIDAD DE RUTA',
    route: 'ChangeRouteLocality',
  }],
}, {
  groups: ['2', '3', '5', '6'],
  title: 'SEGUIMIENTO',
  route: 'TracingV1',
  icon: 'fas fa-eye',
}, {
  groups: [],
  title: 'SEGUIMIENTO',
  route: 'TracingEnterpriseV1',
  icon: 'fas fa-eye',
}, {
  groups: ['1', '2', '3'],
  title: 'TRANSPORTES',
  route: 'Vehicles',
  icon: 'fas fa-truck',
}];

const sideMenu = () => new Promise((resolve) => {
  const accountType = decodeRSA(sessionStorage.type);
  const countryCode = decodeRSA(sessionStorage.country);
  resolve(menu.filter(e => e.groups.indexOf(accountType) !== -1)
    .map(({ groups, ...s }, index) => {
      // eslint-disable-next-line no-param-reassign
      s.index = `${index}`;
      if (s.children) {
        // eslint-disable-next-line no-param-reassign
        s.children = s.children
          .map((c, childI) => ({ ...c, index: `${index}-${childI}` }))
          .filter(e => (!e.groups || e.groups.indexOf(accountType) !== -1)
            && (countryCode === 'PE' || e.route !== 'ImportPoints'));
      }
      return s;
    }));
});
export default sideMenu;
